import { render, staticRenderFns } from "./forgot-userdata.vue?vue&type=template&id=76c338a2"
import script from "./forgot-userdata.vue?vue&type=script&lang=js"
export * from "./forgot-userdata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports